import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import XCloseIcon from "assets/icons/HeroIcons/XCloseIcon";
import { RootState } from "store";
import { useSelector } from "react-redux";
import { closeArchiveOrRestoreQualityAssuranceObservationModalAction } from "store/modals/reducer.actions";
import { useDispatch } from "react-redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import Button from "view/components/Button";
import { useNavigate } from "react-router-dom";
import {
  qualityAssuranceObservationsStatusAction,
} from "store/filters";
const style: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  // width: auto,
  backgroundColor: "#ffff",
};

interface ArchiveOrRestoreQualityAssuranceModalProps {}

export const ArchiveOrRestoreQualityAssuranceModal: React.FC<
  ArchiveOrRestoreQualityAssuranceModalProps
> = () => {
  const { archiveOrRestoreQualityAssuranceObservationModal } = useSelector(
    (state: RootState) => state.modals
  );
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    dispatch(closeArchiveOrRestoreQualityAssuranceObservationModalAction());
  };
  const navigate = useNavigate();

  const archiveOrRestoreQualityAssuranceObservationClick = async () => {
    setIsLoading(true);

    try {
      const res = await apiLibrary.Observations.changeObservationStatus(
        archiveOrRestoreQualityAssuranceObservationModal?.data?.id,
        archiveOrRestoreQualityAssuranceObservationModal?.data?.status ===
          "archived"
          ? "restore"
          : "archived"
      );
      Toasts.success(res.message);
      dispatch(
        qualityAssuranceObservationsStatusAction(
          archiveOrRestoreQualityAssuranceObservationModal?.data?.status ===
            "archived"
            ? "completed"
            : "archived"
        )
      );

      if (
        archiveOrRestoreQualityAssuranceObservationModal?.data.path ===
        "profilePage"
      ) {
        navigate("/quality-assurance/list");
      }
      handleClose();
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error.message;
      Toasts.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={archiveOrRestoreQualityAssuranceObservationModal?.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      disableAutoFocus={true}
      aria-describedby="modal-modal-description"
      className="border-none"
    >
      <Box sx={style} className="dark:bg-secondaryLight ">
        <div className="flex flex-col justify-start items-start w-[480px] rounded-lg">
          <div
            className="relative flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 p-6 rounded-lg dark:bg-secondaryLight bg-bgWhite"
            style={{
              boxShadow:
                "0px 2px 8px 0 rgba(2,13,36,0.1), 0px 2px 24px 0 rgba(2,13,36,0.08)",
            }}
          >
            <div className="flex  justify-between items-start self-stretch flex-grow-0 flex-shrink-0 py-0.5">
              <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0">
                <p className="flex-grow text-xl font-semibold text-left text-textMid dark:text-textMain">
                  {archiveOrRestoreQualityAssuranceObservationModal?.data
                    ?.status === "archived"
                    ? "Restore Observation"
                    : "Archive Observation"}
                </p>
              </div>
              <button onClick={handleClose} type="button">
                <XCloseIcon width={24} height={24} viewBox="0 0 24 24" />
              </button>
            </div>
            <div className="flex justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-2 pb-1.5">
              {archiveOrRestoreQualityAssuranceObservationModal?.data
                ?.status === "archived" ? (
                <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-textMain">
                  Are you sure you want to restore this observation?
                </p>
              ) : (
                <p className="flex-grow w-[432px] text-sm text-left text-textMid  dark:text-textMain">
                  Are you sure you want to archive this observation? You can
                  always restore this observation at a later point in time in
                  order to resume the observation.
                </p>
              )}
            </div>

            <div className="flex items-center self-stretch justify-end flex-grow-0 flex-shrink-0 gap-2">
              <Button
                type="button"
                text="Cancel"
                filledColor="primary"
                outlinedColor="primary"
                textColor="textWhite"
                className="px-5 py-2"
                width="35"
                height="13"
                fontStyle="font-semibold"
                variant="outlined"
                onClick={handleClose}
              />

              <Button
                disabled={isLoading}
                type="button"
                text={
                  archiveOrRestoreQualityAssuranceObservationModal?.data
                    ?.status === "archived"
                    ? "Yes, Restore"
                    : "Yes, Archive"
                }
                filledColor="primary"
                outlinedColor="primary"
                textColor="textWhite"
                className="px-5 py-2"
                width="35"
                height="13"
                fontStyle="font-semibold"
                variant="filled"
                onClick={archiveOrRestoreQualityAssuranceObservationClick}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
